// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/scope.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ConditionMatchType } from "./condition_match_type_pb";
import { file_inventory_v1_condition_match_type } from "./condition_match_type_pb";
import type { Project } from "./project_pb";
import { file_inventory_v1_project } from "./project_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/scope.proto.
 */
export const file_inventory_v1_scope: GenFile = /*@__PURE__*/
  fileDesc("ChhpbnZlbnRvcnkvdjEvc2NvcGUucHJvdG8SDGludmVudG9yeS52MSKhAQoFU2NvcGUSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRITCgtkZXNjcmlwdGlvbhgDIAEoCRIYChBjb25kaXRpb25zX2NvdW50GAQgASgFEhYKDmNvbnRyb2xzX2NvdW50GAUgASgFEisKB3Byb2plY3QYBiABKAsyFS5pbnZlbnRvcnkudjEuUHJvamVjdEgAiAEBQgoKCF9wcm9qZWN0IlcKClNjb3BlSW5wdXQSDAoEbmFtZRgBIAEoCRITCgtkZXNjcmlwdGlvbhgCIAEoCRIXCgpwcm9qZWN0X2lkGAMgASgJSACIAQFCDQoLX3Byb2plY3RfaWQiPgoPQ29uZGl0aW9uc0dyb3VwEisKCmNvbmRpdGlvbnMYASADKAsyFy5pbnZlbnRvcnkudjEuQ29uZGl0aW9uInMKCUNvbmRpdGlvbhI0CgptYXRjaF90eXBlGAEgASgOMiAuaW52ZW50b3J5LnYxLkNvbmRpdGlvbk1hdGNoVHlwZRITCgtxdWVzdGlvbl9pZBgCIAEoCRIbChNzZWxlY3RlZF9hbnN3ZXJfaWRzGAMgAygJQrIBChBjb20uaW52ZW50b3J5LnYxQgpTY29wZVByb3RvUAFaQWdpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vaW52ZW50b3J5L3YxO2ludmVudG9yeXYxogIDSVhYqgIMSW52ZW50b3J5LlYxygIMSW52ZW50b3J5XFYx4gIYSW52ZW50b3J5XFYxXEdQQk1ldGFkYXRh6gINSW52ZW50b3J5OjpWMWIGcHJvdG8z", [file_inventory_v1_condition_match_type, file_inventory_v1_project]);

/**
 * @generated from message inventory.v1.Scope
 */
export type Scope = Message<"inventory.v1.Scope"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: int32 conditions_count = 4;
   */
  conditionsCount: number;

  /**
   * @generated from field: int32 controls_count = 5;
   */
  controlsCount: number;

  /**
   * @generated from field: optional inventory.v1.Project project = 6;
   */
  project?: Project;
};

/**
 * Describes the message inventory.v1.Scope.
 * Use `create(ScopeSchema)` to create a new message.
 */
export const ScopeSchema: GenMessage<Scope> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope, 0);

/**
 * @generated from message inventory.v1.ScopeInput
 */
export type ScopeInput = Message<"inventory.v1.ScopeInput"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: optional string project_id = 3;
   */
  projectId?: string;
};

/**
 * Describes the message inventory.v1.ScopeInput.
 * Use `create(ScopeInputSchema)` to create a new message.
 */
export const ScopeInputSchema: GenMessage<ScopeInput> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope, 1);

/**
 * @generated from message inventory.v1.ConditionsGroup
 */
export type ConditionsGroup = Message<"inventory.v1.ConditionsGroup"> & {
  /**
   * @generated from field: repeated inventory.v1.Condition conditions = 1;
   */
  conditions: Condition[];
};

/**
 * Describes the message inventory.v1.ConditionsGroup.
 * Use `create(ConditionsGroupSchema)` to create a new message.
 */
export const ConditionsGroupSchema: GenMessage<ConditionsGroup> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope, 2);

/**
 * @generated from message inventory.v1.Condition
 */
export type Condition = Message<"inventory.v1.Condition"> & {
  /**
   * @generated from field: inventory.v1.ConditionMatchType match_type = 1;
   */
  matchType: ConditionMatchType;

  /**
   * @generated from field: string question_id = 2;
   */
  questionId: string;

  /**
   * @generated from field: repeated string selected_answer_ids = 3;
   */
  selectedAnswerIds: string[];
};

/**
 * Describes the message inventory.v1.Condition.
 * Use `create(ConditionSchema)` to create a new message.
 */
export const ConditionSchema: GenMessage<Condition> = /*@__PURE__*/
  messageDesc(file_inventory_v1_scope, 3);

